import { TypeAnimation } from 'react-type-animation'
import './myCss.css'

const DeveloperComponent = () => {
    return (
     <>
        <TypeAnimation sequence = {[
            'front end dev_.', 2000,
            'React dev_.', 2000,
            'data analyst_.', 2000,
            'full stack dev_.', 2000,
            'problem solver_.', 2000
        ]}
        wrapper='span'
        cursor={false}
        repeat={Infinity}
        className= 'pos'
        />
        </>
    )
}

export default DeveloperComponent